export enum AxiomaW1BatteryLevel {
  FULL = 'FULL',
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
  CRITICAL = 'CRITICAL',
  EMPTY = 'EMPTY'
}
